import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useMemo
} from 'react';
import { useAutoPilotContext } from 'modules/App/menu/items/Settings/AutoPilotContextProvider';

type DrawerType = {
  expanded: boolean;
  setExpanded: React.Dispatch<React.SetStateAction<boolean>>;
};

export const SmartDiaryDrawerContext = createContext<DrawerType | null>(null);

export const useSmartDiaryDrawerContext = (): DrawerType => {
  const val = useContext(SmartDiaryDrawerContext);
  if (!val) {
    throw new Error(
      'useSmartDiaryDrawerContext must be called within a SmartDiaryDrawerContextProvider'
    );
  }
  return val;
};

const SmartDiaryDrawerContextProvider: React.FC = ({
  children
}: {
  children?: React.ReactNode;
}) => {
  const { isAutoPilotEnabled } = useAutoPilotContext();
  const [expanded, setExpanded] = useState(!isAutoPilotEnabled);
  useEffect(() => {
    setExpanded(!isAutoPilotEnabled);
  }, [isAutoPilotEnabled]);

  const value = useMemo(() => {
    return {
      expanded,
      setExpanded
    };
  }, [expanded]);

  return (
    <SmartDiaryDrawerContext.Provider value={value}>
      {children}
    </SmartDiaryDrawerContext.Provider>
  );
};

export default SmartDiaryDrawerContextProvider;
